import _ from "lodash";
import { mapState } from "vuex";

export const SetSubmittedDefaults = {
  data() {
    return {};
  },
  computed: {
    ...mapState({})
  },
  methods: {
    async setSubmittedDefaults() {
      let arr = [];

      if (this.form.data.fields.filter(a => Array.isArray(a)).length <= 0) {
        return;
      }

      if (this.form.data.customertype && this.SubmitData.customertype) {
        this.form.data.customertype = this.SubmitData.customertype;
      }

      this.products.forEach(b => {
        arr.push({ key: b.id, value: b.group });
      });

      if (_.isEmpty(this.SubmitData.products)) {
        this.removeDefaultsAll();
        return;
      }

      //fill initials
      this.form.data.fields
        .filter(a => Array.isArray(a) && a.length > 0)
        .forEach(x => {
          //available
          if (
            x[0].product === 6 &&
            !this.SubmitData.products["electricityandgas"]
          ) {
            return;
          }

          //set default
          if (
            x[0].product !== this.enums.mobile.value &&
            x[0].product !== this.enums.internet.value &&
            x[0].product !== this.enums.insurance.value &&
            this.SubmitData.products[x[0].group]
          ) {
            x.filter(f => f.type === "suppliers")[0].default = parseInt(
              this.SubmitData.products[x[0].group].proposition
            );
          }
          //set default duration
          if (
            this.SubmitData.products[x[0].group] &&
            this.SubmitData.products[x[0].group].duration
          ) {
            if (x.filter(a => a.type == "duration").length > 0) {
              x.filter(a => a.type == "duration")[0].default = parseInt(
                this.SubmitData.products[x[0].group].duration
              );
            }
          }

          if (
            x.filter(f => f.type === "suppliers").length > 0 &&
            x.filter(f => f.type === "suppliers")[0].groupDefault !== undefined
          ) {
            //set status (insurance)
            if (
              x[0].product == this.enums.insurance.value &&
              this.SubmitData.products[x[0].group]
            ) {
              this.setSubmittedStatus(
                x.filter(f => f.type == "suppliers")[0].suppliers,
                this.SubmitData.products[x[0].group].proposition
              );
            }

            //set group default
            x.filter(f => f.type === "suppliers")[0].groupDefault = this
              .SubmitData.products[x[0].group]
              ? parseInt(this.SubmitData.products[x[0].group].supplier_id)
              : null;

            x.filter(f => f.type === "suppliers")[0].groupDefaultOld = x.filter(
              f => f.type === "suppliers"
            )[0].groupDefault;

            if (
              x.filter(f => f.type === "suppliers")[0].suppliers.length > 0 &&
              this.SubmitData.products[x[0].group]
            ) {
              // not mobile and internet set supplier default
              if (
                x[0].product !== this.enums.mobile.value &&
                x[0].product !== this.enums.internet.value
              ) {
                x.filter(f => f.type === "suppliers")[0].suppliers.forEach(
                  d => {
                    d.default = parseInt(
                      this.SubmitData.products[x[0].group].proposition
                    );
                  }
                );
              }
              // mobile and internet
              else if (
                x[0].product === this.enums.mobile.value ||
                x[0].product === this.enums.internet.value
              ) {
                //set shows
                x.filter(a => a.type === "suppliers")[0].suppliers.forEach(
                  sup => {
                    if (
                      sup.supplier_id ==
                      x.filter(a => a.type === "suppliers")[0].groupDefault
                    ) {
                      sup.show = 1;
                    } else {
                      sup.show = 0;
                    }
                  }
                );

                if (this.SubmitData.products[x[0].group].package) {
                  x.filter(f => f.type === "suppliers")[0].suppliers.forEach(
                    e => {
                      e.default = null;
                      for (let value of Object.values(
                        this.SubmitData.products[x[0].group].package
                      )) {
                        if (e.id === parseInt(value)) {
                          e.default = e.id;
                        }
                      }
                    }
                  );
                } else {
                  x.filter(f => f.type === "suppliers")[0].suppliers.forEach(
                    e => {
                      e.default = null;
                      if (
                        e.id ===
                        parseInt(
                          this.SubmitData.products[x[0].group].proposition
                        )
                      ) {
                        e.default = e.id;
                      }
                    }
                  );
                }
              }
            }
          }
        });

      if (_.isEmpty(this.SubmitData.products)) {
        return;
      }
      arr.forEach(item => {
        if (
          this.SubmitData.products[item.value] &&
          this.SubmitData.products[item.value].id
        ) {
          if (!this.defaultProducts.includes(parseInt(item.key))) {
            this.form.data.fields
              .filter(
                a =>
                  a.type == "products" &&
                  a.products.findIndex(b => b.id == item.key) >= 0
              )[0]
              .defaultProducts.push(parseInt(item.key));
          }
        } else {
          if (this.defaultProducts.findIndex(a => a === item.key) !== -1) {
            this.removeDefaults(
              item.key,
              this.form.data.fields.filter(
                a =>
                  a.type == "products" &&
                  a.products.findIndex(b => b.id == item.key) >= 0
              )[0]
            );
          }
        }
      });

      return true;
    },
    removeDefaults(item, data) {
      if (this.checkElectricGas && (item === 1 || item === 2)) {
        if (data.defaultProducts.includes(6)) {
          data.defaultProducts.splice(data.defaultProducts.indexOf(6), 1);
        }
      }
      data.defaultProducts.splice(data.defaultProducts.indexOf(item), 1);
    },
    removeDefaultsAll() {
      // this.form.data.fields.filter(
      //   (a) =>
      //     a.type == "products"
      // )[0].defaultProducts = []

      if (this.form.data.fields.filter(a => a.type == "products").length > 0) {
        this.form.data.fields
          .filter(a => a.type == "products")
          .forEach(field => (field.defaultProducts = []));
      }
    },
    setSubmittedStatus(arr, propositions) {
      if (arr && propositions) {
        arr.forEach(el => {
          if (Object.keys(propositions).includes(el.id.toString())) {
            el.status = 1;
          } else {
            el.status = 0;
          }
        });
      } else if (arr && !propositions) {
        arr.forEach(el => {
          el.status = 0;
        });
      }
    }
  }
};
